var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscrption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.354 9.646l6.792-6.792 3 3-6.792 6.792-3-3zm-.556.86l2.697 2.696-3.412 1.365a.5.5 0 0 1-.65-.65l1.365-3.412zm8.056-8.36l.732-.732a2 2 0 0 1 2.828 0l.172.172a2 2 0 0 1 0 2.828l-.732.732-3-3zM12.172 2l-2 2H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9.828l2-2V15a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h7.172z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscrption);
export default __webpack_public_path__ + "static/media/subscrption.f23f737c10f87438d068ce7e9fe10b03.svg";
export { ForwardRef as ReactComponent };